import { render } from "./SideNav.vue?vue&type=template&id=bb89ffbe&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=bb89ffbe&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/VueJS/marco-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb89ffbe"]])

export default __exports__